/* eslint new-cap: [0] */
/* eslint one-var: [0] */
/* eslint max-len: [0] */

import Barba from 'barba.js';
import Utils from './utils.js';
import Animations from './animations.js';

export default class Transitions {
	constructor( settings ) {
		this.router = null;
		if ( typeof settings !== 'undefined' && settings.hasOwnProperty( 'router' ) ){
			this.router = settings.router;
		}	
	}

	_fixWrapper( transition ){
		const $wrapper = jQuery( `#${Barba.Pjax.Dom.wrapperId}` );
		$wrapper.addClass( 'is-fixed' );
		gsap.set( $wrapper, {
			height: jQuery( transition.oldContainer ).height()
		} );		
	}

	_unfixWrapper(){
		const $wrapper = jQuery( `#${Barba.Pjax.Dom.wrapperId}` );
		if ( $wrapper.hasClass( 'is-fixed' ) ){
			$wrapper.attr( 'style', '' ).removeClass( 'is-fixed' );	
		}
	}

	_normalize( transition ){
		if ( jQuery( transition.newContainer ).data( 'namespace' ) !== 'event' ){
			this._unfixWrapper();
			Utils.scrollLock( false );
		}
	}

	_wrapper( transition, fnNameTransitionOut, fnNameTransitionIn ){
		const self = this,
			onInitTransition = [transition.newContainerLoading],
			onOldPageLeave = [transition[fnNameTransitionOut].call( transition )], // eslint-disable-line
			onNewPageEnter = []; // empty at start

		let oldPageAnimationLeave = false,
			newPageAnimationEnter = false;
		
		if ( Animations.hasOwnProperty( jQuery( transition.oldContainer ).data( Barba.Pjax.Dom.dataNamespace ) ) 
			&& Animations[jQuery( transition.oldContainer ).data( Barba.Pjax.Dom.dataNamespace )].hasOwnProperty( 'leave' ) ){
			oldPageAnimationLeave = Animations[jQuery( transition.oldContainer ).data( Barba.Pjax.Dom.dataNamespace )].leave( transition );
			
			if ( oldPageAnimationLeave.hasOwnProperty( 'timeline' ) ){
				oldPageAnimationLeave = Utils.timelinePromise( oldPageAnimationLeave );
			}
			
			onInitTransition.push( oldPageAnimationLeave );
		}

		Promise
			.all( onInitTransition )
			.then( () => Promise.all( onOldPageLeave ) )
			.then( () => {
				// Push transition in to promises
				onNewPageEnter.push( transition[fnNameTransitionIn].call( transition ) ); // eslint-disable-line

				// check if new page has enter animation
				if ( Animations.hasOwnProperty( jQuery( transition.newContainer ).data( Barba.Pjax.Dom.dataNamespace ) ) 
					&& Animations[jQuery( transition.newContainer ).data( Barba.Pjax.Dom.dataNamespace )].hasOwnProperty( 'enter' ) ){
					newPageAnimationEnter = Animations[jQuery( transition.newContainer ).data( Barba.Pjax.Dom.dataNamespace )].enter( transition );
				}

				return Promise.all( onNewPageEnter );
			} )
			.then( () => {
				// if new page has enter animation -> fire animation
				if ( newPageAnimationEnter !== false ){
					newPageAnimationEnter.play();
				}
				
				transition.done();
			} );
	}

	noTransition() {
		const self = this;
    
		return Barba.BaseTransition.extend( {
			start() {
				this.newContainerLoading.then( this.finish.bind( this ) );
			},
		
			finish() {
				const _this = this;
				
				self._normalize( _this );

				if ( jQuery( window ).scrollTop() > jQuery( '#site__navigation' ).height() ){
					jQuery( 'html, body' ).animate( {
						scrollTop: 0
					}, 500 ).promise().then( () => {
						_this.done();
					} );
				} else {
					this.done();
				}
			}
		} );
	}

	baseTransition() {
		const self = this;

		return Barba.BaseTransition.extend( {
			start(){
				const _this = this;
				if ( jQuery( this.oldContainer ).data( 'namespace' ) !== 'event' ){
					if ( jQuery( window ).scrollTop() > jQuery( '#site__navigation' ).height() ){
						jQuery( 'html, body' ).animate( {
							scrollTop: 0
						}, 500 ).promise().then( () => {
							self._wrapper( _this, 'fadeOut', 'fadeIn' );
						} );
					} else {
						self._wrapper( this, 'fadeOut', 'fadeIn' );
					}
				} else {
					self._wrapper( this, 'fadeOut', 'fadeIn' );
				}
			},
			fadeOut(){
				const _this = this,
					tlFadeOut = gsap.timeline( {
						paused: false
					} );

				tlFadeOut.to( this.oldContainer, 0.5, {
					autoAlpha: 0
				} );

				return Utils.timelinePromise( tlFadeOut );
			},			
			fadeIn(){
				const _this = this,
					tlFadeIn = gsap.timeline( {
						paused: false,
						onStart(){
							jQuery( _this.oldContainer ).hide();
						},
						onComplete(){
							self._normalize( _this );
						}
					} );

				gsap.set( this.newContainer, {
					visibility: 'visible',
					opacity: 0,
				} );

				tlFadeIn.to( this.newContainer, 0.5, {
					autoAlpha: 1
				} );

				return Utils.timelinePromise( tlFadeIn );
			}
		} );
	}

	preloaderTransition(){
		const self = this;
		
		window.location.href = window.location.href;
		
		return true;

		/*
		 * return Barba.BaseTransition.extend( {
		 * 	start(){
		 * 		const _this = this;
		 * 		Promise
		 * 			.all( [OAX.preloader.restart(), this.newContainerLoading] )
		 * 			.then( this.hide.bind( this ) );
		 * 	},
		 * 	hide(){
		 * 		console.log( this, window.location.href );
		 * 		window.scrollTo( 0, 0 );
		 * 		OAX.preloader.hide();
		 * 		this.done();
		 * 	}
		 * } );
		 */
	}

	morphTransitionIn( HTMLElement ){
		const self = this,
			$el = jQuery( HTMLElement );

		return Barba.BaseTransition.extend( { 
			start() {
				// As soon the loading is finished and the old page is faded out, let's fade the new page
				Promise
					.all( [this.newContainerLoading] )
					.then( this.morphIn.bind( this ) )
					.then( this.showNewContainer.bind( this ) );
			},
			setMorph(){
				/**
				 * Um DIe Performance zu verbessern, sollte hier auf getComputedStyle() verzichtet werden!!!
				 */

				this.$morphContainer = jQuery( '<div class="c-transition-morph fixed z-overlay"></div>' );
				this.$morphContainerBG = jQuery( '<div class="c-transition-morph-bg fixed z-overlay"></div>' );

				this.$morphContainerIMG = jQuery( '<img class="absolute top-0 left-0 w-full h-full object-fit-cover">' );
				this.$morphContainerIMG.attr( 'src', $el.find( 'img' ).attr( 'src' ) );

				this.$newContainer = jQuery( this.newContainer );
				this.$oldContainer = jQuery( this.oldContainer );
				this.minusMarginTop = jQuery( '#site__header' ).height() * -1;
				this.currentPosEl = {
					top: $el.offset().top - jQuery( document ).scrollTop(),
					left: $el.offset().left
				};

				console.log( $el.width(), $el.height() );
				/*
				 * this.currentDimEl = {
				 * width: parseInt(window.getComputedStyle( $el.get( 0 ), null ).getPropertyValue( 'width' ), 10),
				 * height: parseInt(window.getComputedStyle( $el.get( 0 ), null ).getPropertyValue( 'height' ), 10)
				 * };
				 */
				this.currentDimEl = {
					width: $el.width(),
					height: $el.height()
				};				
				console.log( this.currentDimEl );
				
				this.currentBGColor = OAX.style.theme_color.base_1.rgb.css;		
				
				console.log( this.$newContainer.find( '.c-event-single__header-media' ).width(), this.$newContainer.find( '.c-event-single__header-media' ).height() );				
				this.toDim = {
					width: this.$newContainer.find( '.c-event-single__header-media' ).width() + 2,
					height: this.$newContainer.find( '.c-event-single__header-media' ).height() + 1
				};
				/*
				 * this.toDim = {
				 * width: parseInt(window.getComputedStyle( this.$newContainer.find( '.c-event-single__header-media' ).get( 0 ), null ).getPropertyValue( 'width' ), 10) + 2,
				 * height: parseInt(window.getComputedStyle( this.$newContainer.find( '.c-event-single__header-media' ).get( 0 ), null ).getPropertyValue( 'height' ), 10) + 1
				 * };
				 */
				console.log( this.toDim );

				gsap.set( this.$morphContainerIMG, {
					autoAlpha: 0
				} );
				
				gsap.set( this.$morphContainerBG, {
					right: 0,
					bottom: 0,
					width: jQuery( window ).width() - parseInt( this.$newContainer.find( '.c-event-single' ).css( 'margin-left' ), 10 ),
					height: '100vh',
					zIndex: 999998,
					backgroundColor: 'white',
					x: '100%'
				} );

				gsap.set( this.$morphContainer, {
					left: this.currentPosEl.left,
					top: this.currentPosEl.top,
					width: this.currentDimEl.width,
					height: this.currentDimEl.height,
					zIndex: 999999,
					backgroundColor: this.currentBGColor,
					autoAlpha: 0 
				} );

				gsap.set( this.$newContainer, {
					autoAlpha: 0,
				} );

				// this.$morphContainer.append( this.$morphContainerIMG );				
				jQuery( 'body' ).append( this.$morphContainer );
				jQuery( 'body' ).append( this.$morphContainerBG );
			},
			morphIn(){
				const _this = this;

				this.setMorph();

				const tlMorphIn = gsap.timeline( {
					paused: false,
					onComplete(){
						self._fixWrapper( _this );					
						Utils.scrollLock( true );
					}
				} );

				tlMorphIn
					.to( this.$morphContainer, 0.2, {
						autoAlpha: 1
					} )
					.set( $el, {
						autoAlpha: 0
					} )
					.to( this.$morphContainerBG, 0.4, {
						x: '0%'
					} )
					.to( this.$morphContainer, 0.7, {
						scale: 1,
						left: parseInt( this.$newContainer.find( '.c-event-single' ).css( 'margin-left' ), 10 ),
						top: jQuery( 'body' ).hasClass( 'admin-bar' ) ? 32 : 0,
						width: this.toDim.width,
						height: this.toDim.height
					}, '-=0.7' );
				
				this.tlMorphIn = tlMorphIn;

				return Utils.timelinePromise( this.tlMorphIn, 0.5 );
			},
			showNewContainer(){
				const _this = this,
					$backbtn = this.$newContainer.find( '.c-page-back-btn' ),
					tlShowNewContainer = gsap.timeline( {
						paused: true,
						onComplete(){
							_this.done();
							gsap.to( _this.$morphContainer, 0.3, {
								autoAlpha: 0,
								onComplete(){
									$backbtn.removeAttr( 'disabled' ).removeClass( 'opacity-0' );
									_this.$morphContainer.remove();
									_this.$morphContainerBG.remove();
									Barba.Pjax.getTransition = function(){
										return self.slideTransitionOut();
									};
								}
							} );
						}
					} );
				
				$backbtn.addClass( 'transition-rotate-arrow opacity-0' ).attr( 'disabled', true );

				gsap.set( this.$newContainer.find( '.c-event-single__header-media' ), {
					autoAlpha: 1
				} );	
				gsap.set( this.$newContainer.find( '.c-event-single__aside ' ), {
					autoAlpha: 0,
					y: 50
				} );	
				gsap.set( this.$newContainer.find( '.c-event-single__body ' ), {
					autoAlpha: 0
				} );		
				gsap.set( this.$newContainer.find( '.c-event-single__footer ' ), {
					autoAlpha: 0
				} );	

				tlShowNewContainer
					.to( this.$newContainer, 0.5, {
						autoAlpha: 1
					} )
					.to( this.$morphContainer, 0.5, {
						autoAlpha: 0
					} )	
					.to( this.$morphContainerBG, 0.5, {
						autoAlpha: 0
					}, '-=0.5' )
					.from( this.$newContainer.find( '.c-event-single__header-title-container h1' ), 0.5, {
						x: '-2%',
						autoAlpha: 0
					}, '-=0.2' )
					.from( this.$newContainer.find( '.c-event-single__header-title-container h1 span' ), 0.5, {
						x: '4%',
						autoAlpha: 0
					}, '-=0.5' )
					.to( this.$newContainer.find( '.c-event-single__aside' ), 0.5, {
						autoAlpha: 1,
						y: 0
					} )
					.to( this.$newContainer.find( '.c-event-single__body, .c-event-single__footer' ), 0.5, {
						autoAlpha: 1
					}, '-=0.5' );
				
				tlShowNewContainer.play();
			}
		} );
	}

	slideTransitionIn(){
		const self = this;

		return Barba.BaseTransition.extend( { 
			start() {
				// As soon the loading is finished and the old page is faded out, let's fade the new page
				Promise
					.all( [this.newContainerLoading] )
					.then( this.slideIn.bind( this ) );
			},

			slideIn() {
				const _this = this,
					$newContainer = jQuery( this.newContainer ),
					$oldContainer = jQuery( this.oldContainer ),
					minusMarginTop = -jQuery( '#site__header' ).height();
				
				self._fixWrapper( _this );				
				Utils.scrollLock( true );				
				
				gsap.set( $newContainer, {
					visibility: 'visible',
					zIndex: 9999999,
					right: 0,
					x: '100%'
				} );

				$newContainer.find( '.c-page-back-btn' ).addClass( 'transition-rotate-arrow' );

				gsap.to( $newContainer, 0.5, {
					x: '0%',
					ease: Power2.easeOut,
					onComplete(){
						_this.done();

						// Reset Transition if User Clicks on Back
						Barba.Pjax.getTransition = function(){
							return self.slideTransitionOut();
						};
					}
				} );
			}
		} );
	}

	slideTransitionOut(){
		const self = this;

		return Barba.BaseTransition.extend( { 
			start() {
				// As soon the loading is finished and the old page is faded out, let's fade the new page
				Promise
					.all( [this.newContainerLoading] )
					.then( this.slideOut.bind( this ) );
			},

			slideOut() {
				const _this = this,
					$oldContainer = jQuery( this.oldContainer ),
					$newContainer = jQuery( this.newContainer );
				
				const tlSlideOut = gsap.timeline( {
					onComplete(){
						_this.done();
						jQuery( '#site__body' ).css( 'height', '' );
						Utils.scrollLock( false );
					}					
				} );

				tlSlideOut
					.to( $oldContainer, 0.5, {
						x: '100%'
					} )
					.to( $newContainer, 0.5, {
						autoAlpha: 1
					} );

				Utils.timelinePromise( tlSlideOut, 0.9 );
			}
		} );
	}	
}
